import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Collapse, Menu, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import CardTravelOutlinedIcon from "@material-ui/icons/CardTravelOutlined";
import useStyles from "./styles";
import { withRouter } from "react-router-dom";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
var HeaderMenu = function HeaderMenu(_ref) {
  var onClose = _ref.onClose,
    anchorEl = _ref.anchorEl,
    open = _ref.open,
    history = _ref.history;
  var _useState = useState({
      kits: true,
      orders: true
    }),
    _useState2 = _slicedToArray(_useState, 2),
    collapse = _useState2[0],
    setCollapse = _useState2[1];
  var _useAuth = useAuth0(),
    isVA = _useAuth.isVA;
  var classes = useStyles();
  var inCatalog = location.href.toLowerCase().includes(window.appConfig.catalogUrl);
  var onClickLink = function onClickLink(url) {
    onClose();
    inCatalog ? window.location.assign(window.appConfig.ordersUrl + url) : history.push(url);
  };
  return React.createElement(Menu, {
    id: "profile-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: onClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    PaperProps: {
      style: {
        width: 230
      }
    }
  }, React.createElement(List, null, (!window.appConfig.features.enableUserAdmin || window.appConfig.features.enableUserAdmin && !isVA) && React.createElement(ListItem, {
    id: "headerMenu-dashboard-test-catalog",
    button: true,
    onClick: function onClick() {
      return window.location.assign(window.appConfig.catalogUrl);
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z",
    fill: "#0C2340"
  }))), React.createElement(ListItemText, {
    primary: "Test Catalog",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })), React.createElement(ListItem, {
    id: "headerMenu-dashboard",
    button: true,
    onClick: function onClick() {
      return onClickLink("/dashboard");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M13 9V3H21V9H13ZM3 13V3H11V13H3ZM13 21V11H21V21H13ZM3 21V15H11V21H3ZM5 11H9V5H5V11ZM15 19H19V13H15V19ZM15 7H19V5H15V7ZM5 19H9V17H5V19Z",
    fill: "#0C2340"
  }))), React.createElement(ListItemText, {
    primary: "Dashboard",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })), React.createElement(ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollapse(Object.assign(Object.assign({}, collapse), {
        orders: !collapse.orders
      }));
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M16 4.00195C18.175 4.01395 19.353 4.11095 20.121 4.87895C21 5.75795 21 7.17195 21 9.99995V16C21 18.829 21 20.243 20.121 21.122C19.243 22 17.828 22 15 22H9C6.172 22 4.757 22 3.879 21.122C3 20.242 3 18.829 3 16V9.99995C3 7.17195 3 5.75795 3.879 4.87895C4.647 4.11095 5.825 4.01395 8 4.00195",
    stroke: "#0C2340",
    "stroke-width": "1.5"
  }), React.createElement("path", {
    d: "M8 14H16M7 10.5H17M9 17.5H15",
    stroke: "#0C2340",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), React.createElement("path", {
    d: "M8 3.5C8 3.10218 8.15804 2.72064 8.43934 2.43934C8.72064 2.15804 9.10218 2 9.5 2H14.5C14.8978 2 15.2794 2.15804 15.5607 2.43934C15.842 2.72064 16 3.10218 16 3.5V4.5C16 4.89782 15.842 5.27936 15.5607 5.56066C15.2794 5.84196 14.8978 6 14.5 6H9.5C9.10218 6 8.72064 5.84196 8.43934 5.56066C8.15804 5.27936 8 4.89782 8 4.5V3.5Z",
    stroke: "#0C2340",
    "stroke-width": "1.5"
  }))), React.createElement(ListItemText, {
    primary: "Orders",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  }), collapse.orders ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)), React.createElement(Collapse, {
    in: collapse.orders,
    timeout: "auto",
    unmountOnExit: true
  }, React.createElement(List, {
    disablePadding: true
  }, React.createElement(ListItem, {
    id: "headerMenu-dashboard-search",
    className: classes.nestedItem,
    button: true,
    onClick: function onClick() {
      return onClickLink("/orders");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M20 12V5.749C20.0001 5.67006 19.9845 5.59189 19.9543 5.51896C19.9241 5.44603 19.8798 5.37978 19.824 5.324L16.676 2.176C16.5636 2.06345 16.4111 2.00014 16.252 2H4.6C4.44087 2 4.28826 2.06321 4.17574 2.17574C4.06321 2.28826 4 2.44087 4 2.6V21.4C4 21.5591 4.06321 21.7117 4.17574 21.8243C4.28826 21.9368 4.44087 22 4.6 22H11M8 10H16M8 6H12M8 14H11M20.5 20.5L22 22",
    stroke: "#0C2340",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React.createElement("path", {
    d: "M16 2V5.4C16 5.55913 16.0632 5.71174 16.1757 5.82426C16.2883 5.93679 16.4409 6 16.6 6H20M15 18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z",
    stroke: "#0C2340",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }))), React.createElement(ListItemText, {
    primary: "Search",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })), React.createElement(ListItem, {
    id: "headerMenu-dashboard-en-route",
    className: classes.nestedItem,
    button: true,
    onClick: function onClick() {
      return onClickLink("/orders?status=en-route&orderBy=orderDate&page=1");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5ZM19.5 9.5H17V12H21.46L19.5 9.5ZM6 18.5C6.83 18.5 7.5 17.83 7.5 17C7.5 16.17 6.83 15.5 6 15.5C5.17 15.5 4.5 16.17 4.5 17C4.5 17.83 5.17 18.5 6 18.5ZM20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H9C9 18.66 7.66 20 6 20C4.34 20 3 18.66 3 17H1V6C1 4.89 1.89 4 3 4H17V8H20ZM3 6V15H3.76C4.31 14.39 5.11 14 6 14C6.89 14 7.69 14.39 8.24 15H15V6H3Z",
    fill: "#0C2340"
  }))), React.createElement(ListItemText, {
    primary: "En Route",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })), React.createElement(ListItem, {
    id: "headerMenu-dashboard-accessioned",
    className: classes.nestedItem,
    button: true,
    onClick: function onClick() {
      return onClickLink("/orders?status=accessioned&orderBy=orderDate&page=1");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M17.25 20.3849L15.3075 18.4424L14.25 19.4999L17.25 22.4999L22.5 17.2499L21.4425 16.1924L17.25 20.3849Z",
    fill: "#0C2340"
  }), React.createElement("path", {
    d: "M8.25 6.75C8.66421 6.75 9 6.41421 9 6C9 5.58579 8.66421 5.25 8.25 5.25C7.83579 5.25 7.5 5.58579 7.5 6C7.5 6.41421 7.83579 6.75 8.25 6.75Z",
    fill: "#0C2340"
  }), React.createElement("path", {
    d: "M8.25 12.75C8.66421 12.75 9 12.4142 9 12C9 11.5858 8.66421 11.25 8.25 11.25C7.83579 11.25 7.5 11.5858 7.5 12C7.5 12.4142 7.83579 12.75 8.25 12.75Z",
    fill: "#0C2340"
  }), React.createElement("path", {
    d: "M8.25 18.75C8.66421 18.75 9 18.4142 9 18C9 17.5858 8.66421 17.25 8.25 17.25C7.83579 17.25 7.5 17.5858 7.5 18C7.5 18.4142 7.83579 18.75 8.25 18.75Z",
    fill: "#0C2340"
  }), React.createElement("path", {
    d: "M18 2.25H6C5.60218 2.25 5.22064 2.40804 4.93934 2.68934C4.65804 2.97064 4.5 3.35218 4.5 3.75V20.25C4.5 20.6478 4.65804 21.0294 4.93934 21.3107C5.22064 21.592 5.60218 21.75 6 21.75H12V20.25H6V15.75H19.5V3.75C19.5 3.35218 19.342 2.97064 19.0607 2.68934C18.7794 2.40804 18.3978 2.25 18 2.25ZM18 14.25H6V9.75H18V14.25ZM18 8.25H6V3.75H18V8.25Z",
    fill: "#0C2340"
  }))), React.createElement(ListItemText, {
    primary: "Accessioned",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })), React.createElement(ListItem, {
    id: "headerMenu-dashboard-in-process",
    className: classes.nestedItem,
    button: true,
    onClick: function onClick() {
      return onClickLink("/orders?status=in-process&orderBy=orderDate&page=1");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M21 11.11V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H11.11C12.37 22.24 14.09 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.37 21 11.11ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM5 19V5H7V7H17V5H19V9.68C17.6956 9.06026 16.2314 8.85943 14.8083 9.10507C13.3852 9.35071 12.0731 10.0308 11.0519 11.0519C10.0308 12.0731 9.35071 13.3852 9.10507 14.8083C8.85943 16.2314 9.06026 17.6956 9.68 19H5ZM16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21ZM16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z",
    fill: "#0C2340"
  }))), React.createElement(ListItemText, {
    primary: "In Process",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })), React.createElement(ListItem, {
    id: "headerMenu-dashboard-completed",
    className: classes.nestedItem,
    button: true,
    onClick: function onClick() {
      return onClickLink("/orders?status=reported&orderBy=orderDate&page=1");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M16 20C17.0609 20 18.0783 19.5786 18.8284 18.8284C19.5786 18.0783 20 17.0609 20 16L20 8C20 6.93913 19.5786 5.92172 18.8284 5.17157C18.0783 4.42143 17.0609 4 16 4L9 4C8.73478 4 8.48043 4.10536 8.29289 4.29289C8.10536 4.48043 8 4.73478 8 5C8 5.26522 8.10536 5.51957 8.29289 5.70711C8.48043 5.89464 8.73478 6 9 6L16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8L18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18L9 18C8.73479 18 8.48043 18.1054 8.29289 18.2929C8.10536 18.4804 8 18.7348 8 19C8 19.2652 8.10536 19.5196 8.29289 19.7071C8.48043 19.8946 8.73479 20 9 20L16 20ZM6.292 16.708C6.38498 16.801 6.49536 16.8747 6.61683 16.925C6.73831 16.9754 6.86851 17.0013 7 17.0013C7.13149 17.0013 7.26169 16.9754 7.38317 16.925C7.50465 16.8747 7.61503 16.801 7.708 16.708C7.80098 16.615 7.87473 16.5046 7.92505 16.3832C7.97537 16.2617 8.00126 16.1315 8.00126 16C8.00126 15.8685 7.97537 15.7383 7.92505 15.6168C7.87473 15.4954 7.80098 15.385 7.708 15.292L5.414 13L14 13C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929C14.5196 11.1054 14.2652 11 14 11L5.414 11L7.708 8.708C7.80098 8.61503 7.87473 8.50465 7.92505 8.38317C7.97537 8.26169 8.00126 8.13149 8.00126 8C8.00126 7.86851 7.97537 7.73831 7.92505 7.61683C7.87473 7.49536 7.80098 7.38498 7.708 7.292C7.61502 7.19903 7.50465 7.12527 7.38317 7.07495C7.26169 7.02464 7.13149 6.99874 7 6.99874C6.86851 6.99874 6.73831 7.02464 6.61683 7.07495C6.49535 7.12527 6.38498 7.19903 6.292 7.292L2.292 11.292C2.19887 11.3849 2.12499 11.4952 2.07458 11.6167C2.02416 11.7382 1.99821 11.8685 1.99821 12C1.99821 12.1315 2.02416 12.2618 2.07458 12.3833C2.12499 12.5048 2.19887 12.6151 2.292 12.708L6.292 16.708Z",
    fill: "#0C2340"
  }))), React.createElement(ListItemText, {
    primary: "Reported",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })), React.createElement(ListItem, {
    id: "headerMenu-dashboard-pending-submission",
    className: classes.nestedItem,
    button: true,
    onClick: function onClick() {
      return onClickLink("/orders?status=pending-submission&orderBy=orderDate&page=1");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM11.0625 17.4375C11.0625 17.6861 11.1613 17.9246 11.3371 18.1004C11.5129 18.2762 11.7514 18.375 12 18.375C12.2486 18.375 12.4871 18.2762 12.6629 18.1004C12.8387 17.9246 12.9375 17.6861 12.9375 17.4375C12.9375 17.1889 12.8387 16.9504 12.6629 16.7746C12.4871 16.5988 12.2486 16.5 12 16.5C11.7514 16.5 11.5129 16.5988 11.3371 16.7746C11.1613 16.9504 11.0625 17.1889 11.0625 17.4375ZM11.4375 15H12.5625C12.6656 15 12.75 14.9156 12.75 14.8125V10.5C12.75 10.3969 12.6656 10.3125 12.5625 10.3125H11.4375C11.3344 10.3125 11.25 10.3969 11.25 10.5V14.8125C11.25 14.9156 11.3344 15 11.4375 15Z",
    fill: "#0C2340"
  }))), React.createElement(ListItemText, {
    primary: "Pending Submission",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })))), !window.appConfig.features.isKitsHidden && React.createElement(React.Fragment, null, React.createElement(ListItem, {
    button: true,
    onClick: function onClick() {
      return setCollapse(Object.assign(Object.assign({}, collapse), {
        kits: !collapse.kits
      }));
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement(CardTravelOutlinedIcon, null)), React.createElement(ListItemText, {
    primary: "Kits"
  }), collapse.kits ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)), React.createElement(Collapse, {
    in: collapse.kits,
    timeout: "auto",
    unmountOnExit: true
  }, React.createElement(List, {
    disablePadding: true
  }, React.createElement(ListItem, {
    id: "headerMenu-dashboard-kits",
    className: classes.nestedItem,
    button: true,
    onClick: function onClick() {
      return onClickLink("/kits");
    }
  }, React.createElement(ListItemIcon, {
    className: classes.listIcon
  }, React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M20 12V5.749C20.0001 5.67006 19.9845 5.59189 19.9543 5.51896C19.9241 5.44603 19.8798 5.37978 19.824 5.324L16.676 2.176C16.5636 2.06345 16.4111 2.00014 16.252 2H4.6C4.44087 2 4.28826 2.06321 4.17574 2.17574C4.06321 2.28826 4 2.44087 4 2.6V21.4C4 21.5591 4.06321 21.7117 4.17574 21.8243C4.28826 21.9368 4.44087 22 4.6 22H11M8 10H16M8 6H12M8 14H11M20.5 20.5L22 22",
    stroke: "#0C2340",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), React.createElement("path", {
    d: "M16 2V5.4C16 5.55913 16.0632 5.71174 16.1757 5.82426C16.2883 5.93679 16.4409 6 16.6 6H20M15 18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z",
    stroke: "#0C2340",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }))), React.createElement(ListItemText, {
    primary: "Search",
    primaryTypographyProps: {
      style: {
        fontFamily: "Barlow",
        fontSize: "17px",
        fontWeight: 500,
        color: "#0C2340"
      }
    }
  })))))));
};
export default withRouter(HeaderMenu);